module.exports = __webpack_public_path__ + "img/AIbox.34e97ed0.png";